/**
 * @generated SignedSource<<30a41587935628a0ab35a3c3f9aa1dae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBuyerChargeCurrency_transaction$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "CheckoutBuyerChargeCurrency_transaction";
};
export type CheckoutBuyerChargeCurrency_transaction$key = {
  readonly " $data"?: CheckoutBuyerChargeCurrency_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBuyerChargeCurrency_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBuyerChargeCurrency_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "53f4e0c6db6a4a2bb3b27d52ff67ed36";

export default node;
